<div class="sen-zone-map mr-2 w-100 border-dark" fxLayout="row">
    <agm-map #AgmMapZone fxFlex="1 1 100%" class="h-100" [disableDefaultUI]="true" [disableDoubleClickZoom]="true"
        [mapTypeId]="'roadmap'" [zoom]="4.8" [latitude]="zoneLat" [longitude]="zoneLon">
        <ng-container *ngFor="let z of zonePathsArray; let i = index">
            <agm-polygon *ngFor="let p of z.zonePaths" [fillColor]="zoneColorArray[z.zoneIndex]" [strokeWeight]="0.5"
                [strokeColor]="zoneColorArray[i]" [visible]="true" [paths]="p">
            </agm-polygon>
        </ng-container>
        <agm-marker *ngIf="showZoneValue" [markerDraggable]="false" [latitude]="markerLat" [longitude]="markerLon">
            <agm-info-window [isOpen]="true">
                <strong>{{zoneType}} <b>{{selectedZoneFromMap}}</b></strong>
            </agm-info-window>
        </agm-marker>
    </agm-map>
</div>